const FTLCredentialListUserNameCell = (data) => {
    return data.username;
};
export default FTLCredentialListUserNameCell;
//# sourceMappingURL=FTLCredentialListUserNameCell.js.map